import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

interface HelpCircleIconProps extends SvgProps {
  hideCircle?: boolean;
}

const HelpCircleIcon = (props: HelpCircleIconProps) => (
  <Svg width={28} height={28} fill="none" {...props}>
    <Path
      d="M14 25.67c6.443 0 11.666-5.224 11.666-11.667 0-6.444-5.223-11.667-11.666-11.667-6.444 0-11.667 5.223-11.667 11.667 0 6.443 5.223 11.666 11.667 11.666Z"
      stroke="#003A70"
      strokeWidth={props.hideCircle ? 0 : 1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M10.605 10.503a3.5 3.5 0 0 1 6.802 1.166c0 2.334-3.5 3.5-3.5 3.5M14 19.836h.014"
      stroke="#003A70"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
);

export default HelpCircleIcon;
